import { DropoffHasEquipmentModel } from "./DropoffHasEquipment.model";

export class DropoffHasEquipment extends DropoffHasEquipmentModel {
    // Add custom methods here
}
